import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ajax-response',
	templateUrl:'./AjaxResponsePluginCompPage.html',
	styles: [],
	styleUrls:['./AjaxResponsePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class AjaxResponsePluginCompPage
{
	mdContent_764 = `\`\`\`java
import com.jwebmp.client.AjaxResponse;
\`\`\``;
	mdContent_765 = `\`\`\`java
AjaxResponse()
\`\`\``;
	mdContent_766 = `\`\`\`java
@Override
public void onClick(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
    response.addComponent(new Paragraph&lt;&gt;().setText("Updated!"));
    response.addReaction(new AjaxResponseReaction("alert", "Done!"));
}
\`\`\``;
}
